import Location from 'app-location'

export const DashboardLocation = new Location('/')
